/**
 * 검수(승인·반려) 뒤 목록 한 줄만 갈아끼우는 규칙.
 *
 * 승인·반려가 서버에서 바꾸는 것은 그 문제 한 건뿐인데, 종전에는 목록을 통째로 다시 읽었다.
 * 그러면 표 자리를 「로딩 중…」이 대신 차지하면서 스크롤이 맨 위로 돌아가는데,
 * Enter 로 훑는 검수에서는 그 일이 승인 한 건마다 일어났다.
 *
 * 그래서 응답(상세 전문)에서 목록 한 줄이 쓰는 값만 뽑아(rowPatchFromReview)
 * 그 줄에 얹는다(applyRowPatch). 목록 조회는 나가지 않는다.
 *
 * 지도 둘(인덱스·분석)은 프로젝트 전량 조회라 여기서 다루지 않는다 —
 * 모달이 지도를 덮고 있는 동안 낡혀 두고 모달이 닫힐 때 한 번 읽는다(ProjectDetailPanel).
 */

// 검수 응답에서 목록 한 줄이 쓰는 값만 뽑는다.
// 승인은 검수 배지 하나만 바꾸지만, 반려는 AI 가 만든 정답·풀이를 지우고 분석을 100(미실행)으로
// 되돌리므로 같은 줄의 「AI 분석」 칸과 구성 표시(● 정답·풀이)까지 함께 바뀐다.
// 응답이 상세 전문이 아니면(계약 변경·순단) 검수 상태만이라도 맞춘다 — 그 값은 방금 우리가 보낸 것이다.
export function rowPatchFromReview(d, action) {
  const fallback = action === 'approve' ? 200 : 400;
  if (!d || d.ocr_prob_id == null) return { review_status: fallback };
  const patch = { review_status: d.review_status ?? fallback };
  if (d.analysis_status !== undefined) patch.analysis_status = d.analysis_status;
  if (Array.isArray(d.flags)) patch.flags = d.flags;
  if (d.answer !== undefined) {
    patch.answer = d.answer;
    patch.has_answer = d.answer != null && String(d.answer).trim() !== '';
  }
  if (d.solution_payload !== undefined || d.solution_lexical !== undefined) {
    patch.has_solution = !!(d.solution_payload || d.solution_lexical);
  }
  return patch;
}

// 규칙 둘: ① 값이 undefined 인 키는 무시한다 — 응답에 없는 필드로 멀쩡한 값을 지우지 않는다.
//         ② 그 문제가 이 페이지에 없으면 배열을 그대로 돌려준다 — 헛 렌더를 만들지 않는다.
export function applyRowPatch(items, id, patch) {
  if (!Array.isArray(items) || id == null || !patch) return items;
  let hit = false;
  const next = items.map((p) => {
    if (String(p.ocr_prob_id) !== String(id)) return p;
    hit = true;
    const merged = { ...p };
    Object.keys(patch).forEach((k) => { if (patch[k] !== undefined) merged[k] = patch[k]; });
    return merged;
  });
  return hit ? next : items;
}
